<template>
  <div class="password_reset">
    <el-steps
      class="psd_process"
      :space="300"
      :active="active"
      finish-status="success"
      :align-center="true"
    >
      <el-step title="输入个人信息"></el-step>
      <el-step title="设置新密码"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>

    <el-carousel
      ref="carousel"
      class="steps_cont"
      :initial-index="0"
      :autoplay="false"
      :loop="false"
      indicator-position="none"
      arrow="never"
    >
      <!-- <el-carousel-item class="step-wrap">
        <div class="step-item__wrap">
          <div class="success"></div>
          <div class="tips">
            <p>密码已经修改成功，一定要保管好你的密码哦~</p>
          </div>
          <el-button class="btn" round type="primary" @click="signInNow">立即登录</el-button>
        </div>
      </el-carousel-item> -->
      <!-- 校验用户是否注册 -->
      <el-carousel-item class="step-wrap check-user">
        <div class="step-item__wrap">
          <el-input placeholder="请输入手机号" v-model="mobile" clearable :maxlength="11"></el-input>
          <el-button
            class="check-user_btn"
            type="primary"
            round
            :disabled="mobileIsLegit"
            @click="checkUserIsRegister"
          >下一步</el-button>
        </div>
      </el-carousel-item>

      <!-- 重置密码 -->
      <el-carousel-item class="step-wrap">
        <div class="step-item__wrap">
          <el-form :model="passwordInfo" ref="resetPsd" :rules="infoRules" label-width="100px">
            <el-form-item label="手机号" props="mobile" required>
              <el-input readonly v-model="passwordInfo.mobile"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="smgCode" required>
              <el-input
                type="text"
                v-model="passwordInfo.smgCode"
                placeholder="请输入验证码"
                clearable
                :maxlength="6"
              >
                <template slot="append">
                  <!-- <span>获取验证码</span> -->
                  <button
                    :disabled="hasSmgCode"
                    class="smg-code_btn"
                    :class="!hasSmgCode ? 'no-smg-code': 'has-code'"
                    @click="_getSmgCode"
                  >{{ !hasSmgCode ? '获取验证码' : '重新获取(' + smgTimes +'s)'}}</button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" required>
              <el-input
                type="password"
                placeholder="请输入新密码（8-16位数字、字母、符号）"
                v-model="passwordInfo.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPsd" required>
              <el-input
                type="password"
                placeholder="请再次输入新密码"
                v-model="passwordInfo.confirmPsd"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="check-user_btn" type="primary" round @click="resetUserPassword">重置密码</el-button>
            </el-form-item>
          </el-form>-->
        </div>
      </el-carousel-item>

      <!-- 重置完成 -->
      <el-carousel-item class="step-wrap">
        <div class="step-item__wrap">
          <div class="success"></div>
          <div class="tips">
            <p>密码已经修改成功，一定要保管好你的密码哦~</p>
          </div>
          <el-button class="btn" round type="primary" @click="signInNow">立即登录</el-button>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// import { checkUserPhoneApi } from '@/api/user'
import { checkUserPhoneApi, getCode, updateUserPsdApi } from '@/api/user'
import md5 from 'js-md5';
import { $Cookies } from '@/utils'

export default {
  name: 'ResetPassword',
  data() {

    var validateSmgCode = (rule, val, cb) => {
      if (val.trim() === '') {
        cb(new Error('请输入验证码'));
      } else {
        const reg = /[0-9]\d{5}/;
        if (!reg.test(Number(val))) {
          cb('验证码无效')
        } else {
          cb()
        }
      }
    }

    var validatePassword = (rule, val, cb) => {
      if (val.trim() === '') {
        cb(new Error('请输入密码'));
      } else {
        cb()
      }
    }

    var validatePassAgain = (rule, val, cb) => {
      if (val.trim() === '') {
        cb(new Error('请再次输入密码'));
      } else if (val !== this.passwordInfo.password) {
        cb(new Error('两次输入密码不一致'))
      } else {
        cb()
      }
    };
    return {
      active: 0,
      mobile: '',
      passwordInfo: {
        mobile: '',
        smgCode: '',
        password: '',
        confirmPsd: '',
      },
      infoRules: {
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        smgCode: [{ validator: validateSmgCode, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPsd: [{ validator: validatePassAgain, trigger: 'blur' }]
      },
      smgTimer: null,
      smgTimes: 60,
      hasSmgCode: false,
      isGetting: false,
    }
  },
  computed: {
    mobileIsLegit: function () {
      if (this.mobile.trim() === '' || this.mobile.trim().length !== 11) {
        return true
      }
      return false
    }
  },
  watch: {
    active: function () {
      this.showSteps()
    }
  },
  mounted() {
    this.showSteps()
  },
  methods: {
    // 校验用户是否注册
    checkUserIsRegister() {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!reg.test(this.mobile.trim())) {
        this.$message.error('请输入正确手机号')
        return
      }

      checkUserPhoneApi(this.mobile).then(res => {
        if (res.success) {
          if (res.result.result === 'success') {
            this.passwordInfo.mobile = this.mobile
            // todo 获取验证码
            // this._getSmgCode()
            this.active = 1
          }
        } else {
          this.$message.error(res.errorMsg)
        }
      })

    },

    // 重置密码
    resetUserPassword(e) {
      e.preventDefault()
      const _ = this
      _.$refs.resetPsd.validate(val => {
        if (val) {
          _._updateUserPsdApi()
        }
      })
    },

    // 调用重置密码接口
    _updateUserPsdApi() {
      updateUserPsdApi({
        phoneRandcode: this.passwordInfo.smgCode,
        mobile: this.passwordInfo.mobile,
        password: md5(this.passwordInfo.password),
      }).then(res => {
        if (res.success) {
          this.active = 3
          this.$message.success('重置密码成功')
          this.$store.dispatch('auth/logout').then(data => {
            if (data.isLogout) {
              $Cookies.remove('uid');
              $Cookies.remove('username');
              this.$message({
                type: 'success',
                message: '密码更换，需要重新登录',
                duration: 1000,
              });
            }
          });
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    // 获取验证码
    _getSmgCode(e) {
      e && e.preventDefault()
      if (this.isGetting) {
        this.$message.error('操作太频繁，请稍后再试')
        return
      } else {
        this.isGetting = true
      }
      getCode({
        mobilePhone: this.mobile,
        platform: 10
      }).then(res => {
        this.isGetting = false
        if (res.success) {
          this.$message.success('验证码发送成功，请注意查收')
          this.hasSmgCode = true
          this.timerTown()
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    // 验证码倒计时
    timerTown() {
      this.smgTimer = setInterval(() => {
        if (this.smgTimes <= 0) {
          clearInterval(this.smgTimer)
          this.smgTimes = 60
          this.hasSmgCode = false
        }
        this.smgTimes--
      }, 1000)
    },

    signInNow() {
      this.$SignIn();
    },

    showSteps() {
      this.$refs.carousel.setActiveItem(this.active)
    },
  },
}
</script>

<style lang="scss">
.password_reset {
  min-height: 450px;
  margin: 40px 0;
  padding: 40px;
  background-color: #fff;
  .psd_process {
    width: 800px;
    margin: 50px auto 0;
  }
  .steps_cont {
    width: 800px;
    margin: 80px auto 0;
    .step-wrap {
      .step-item__wrap {
        width: 450px;
        margin: 0 auto;
        .el-input-group__append {
          padding: 0;
        }
        .smg-code_btn {
          padding: 0 20px;
          background-color: transparent;
          display: block;
          width: 100%;
          height: 38px;
          border: none;
          outline: none;
          cursor: pointer;
        }
        .check-user_btn {
          width: 100%;
        }
        .no-smg-code {
          color: #409eff;
        }
        .has-code {
          color: #909399;
        }
        .success {
          width: 110px;
          height: 110px;
          background: url("~@/assets/images/common/success.png") no-repeat;
          margin: 0 auto 40px;
        }
        .tips {
          font-size: 22px;
          text-align: center;
          width: 460px;
          margin: 0 auto 65px;
        }
        .btn {
          width: 100%;
          font-size: 16px;
        }
      }
    }
  }
  .check-user {
    .check-user_btn {
      display: block;
      width: 100%;
      margin-top: 50px;
    }
  }

  .el-steps {
    .is-process {
      color: #1082ff;
      border-color: #1082ff;
    }
  }
}
</style>